import { createSlice } from "@reduxjs/toolkit";

import { getPermissionsThunk } from "./thunks";
import { PermissionsState } from "./types";

const registration = {
  columns: {
    Actions: { name: "Actions", visible: true },
    Affiliate: { name: "Affiliate", visible: true },
    Autologin: { name: "Autologin", visible: true },
    Brand: { name: "Brand", visible: true },
    BrandStatus: { name: "BrandStatus", visible: true },
    Campaign: { name: "Campaign", visible: true },
    ConvertedAt: { name: "ConvertedAt", visible: true },
    Country: { name: "Country", visible: false },
    CreatedAt: { name: "CreatedAt", visible: true },
    DepositedAt: { name: "DepositedAt", visible: true },
    Email: { name: "Email", visible: false },
    Id: { name: "Id", visible: false },
    Integration: { name: "Integration", visible: true },
    Name: { name: "Name", visible: true },
    Offer: { name: "Offer", visible: true },
    Phone: { name: "Phone", visible: true },
    Status: { name: "Status", visible: false },
  },
  elements: {
    ChangeStatus: {
      disable: true,
      name: "ChangeStatus",
      visible: false,
    },
  },
  filters: {
    AffiliateId: { name: "AffiliateId", visible: false, values: null },
    Affiliates: { name: "Affiliates", visible: false, values: null },
    BrandId: { name: "BrandId", visible: false, values: null },
    BrandStatus: {
      name: "BrandStatus",
      values: [
        "New",
        "FullyActivated",
        "NA",
        "HighPriority",
        "Callback",
        "FailedExpectation",
        "NotValid",
        "NotInterested",
        "Transfer",
        "FollowUp",
        "ConversionRenew",
        "Unknown",
      ],
      visible: true,
    },
  },
  name: "Registrations",
  tabs: null,
  visible: false,
} as any;

const initialState: PermissionsState = {
  permissions: null,
  transformedPermissions: null,
  registration,
  isLoading: false,
  error: {},
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPermissionsThunk.pending, state => {
      state.isLoading = "";
    });
    builder.addCase(getPermissionsThunk.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.permissions = payload.response;
      state.transformedPermissions = payload.transformedPermissions;
      state.registration = payload.transformedPermissions.Registrations;
    });
    builder.addCase(getPermissionsThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export default permissionsSlice.reducer;
